import React from 'react'; // eslint-disable-line
import i18n from '../../i18n';
import GreenCheck from '../svg/GreenCheck';

class ThirdPartyConnect extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleDisconnect = this.handleDisconnect.bind(this);
    }

    handleClick(e) {
        this.props.onClick(e);
    }

    handleDisconnect(e) {
        if (this.props.onDisconnect) {
            this.props.onDisconnect(e);
        }
    }

    render() {
        const {
            ThirdPartyId,
            ThirdPartyTitle,
            ThirdPartyIcon,
            ThirdPartyIconViewBox,
            ThirdPartyIconFillRule,
            ThirdPartyIconFill,
            Connected,
            DataQA,
        } = this.props;
        return (
            <div data-qa={`wrapper-for-${DataQA}`} id={ThirdPartyId} className="other-import">
                {Connected && <div className="green-check" data-qa={`green-check-for-${DataQA}`}><GreenCheck /></div> }
                <div data-qa={`icon-for-${DataQA}`} id={`${ThirdPartyId}-icon`} className="import-icon">
                    <svg width="19" height="22" viewBox={ThirdPartyIconViewBox} xmlns="http://www.w3.org/2000/svg"><path d={ThirdPartyIcon} fillRule={ThirdPartyIconFillRule} fill={ThirdPartyIconFill} /></svg>
                </div>
                <h3 data-qa={`title-for-${DataQA}`} id={`${ThirdPartyId}-title`}>{ThirdPartyTitle}</h3>
                {Connected && (
                    // eslint-disable-next-line react/button-has-type
                    <button data-qa={`disconnect-for-${DataQA}`} id={`${ThirdPartyId}-disconnect`} className="btn btn-sq btn-dark btn-sm dialog-launcher" onClick={this.handleDisconnect}>{i18n.t('disconnect')}</button>
                )}
                {!Connected && (
                    // eslint-disable-next-line react/button-has-type
                    <button data-qa={`connect-for-${DataQA}`} id={`${ThirdPartyId}-connect`} className="btn btn-sq btn-outline btn-sm dialog-launcher" onClick={this.handleClick}>{i18n.t('connect')}</button>
                )}
            </div>
        );
    }
}

export default ThirdPartyConnect;
